import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modals.module.css';

export const RemoveBackgroundModal = ({
  isOpen,
  onClose,
  uniqueImages,
  selectedImages,
  onToggleSelection,
  onSelectAll,
  onRemoveBackground,
  processingBgRemoval
}) => {
  if (!isOpen) return null;

  const validImages = (uniqueImages || []).filter(
    imageData => imageData && imageData.image && imageData.uniqueId
  );
  const selectableImages = validImages.filter(
    imageData => !imageData.image?.backgroundRemoved
  );
  const selectableCount = selectableImages.length;
  const alreadyProcessedCount = validImages.length - selectableCount;

  return ReactDOM.createPortal(
    <div className={styles.removeBgModalOverlay} onClick={onClose}>
      <div className={styles.removeBgModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.removeBgModalHeader}>
          <div className={styles.removeBgModalTitleContainer}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.2477 0.652107C17.8098 0.233566 17.2273 0 16.6215 0C16.0157 0 15.4332 0.233566 14.9952 0.652107L13.3666 2.27838L6.61921 9.02579C6.32542 9.321 6.11669 9.68998 6.01501 10.0939L5.3441 12.7775C5.28708 13.0031 5.28217 13.2388 5.32972 13.4666C5.37728 13.6944 5.47606 13.9084 5.61859 14.0924C5.76111 14.2763 5.94364 14.4255 6.15234 14.5284C6.36104 14.6314 6.59045 14.6855 6.82317 14.6867C6.95035 14.6866 7.07705 14.6709 7.20041 14.6399L9.88403 13.969C10.2884 13.8676 10.6576 13.6583 10.9521 13.3633L17.6995 6.61589L19.3266 4.98961C19.7578 4.55825 20 3.97328 20 3.36334C20 2.75339 19.7578 2.16842 19.3266 1.73706L18.2477 0.652107ZM9.87176 12.2791C9.77362 12.3773 9.65065 12.447 9.51599 12.4808L6.83237 13.1524L7.50404 10.4688C7.53746 10.334 7.6069 10.2107 7.70493 10.1123L13.911 3.90696L16.0801 6.07533L9.87176 12.2791ZM18.2477 3.90466L17.162 4.98885L14.9929 2.82048L16.0778 1.73629C16.2238 1.59672 16.418 1.51882 16.6199 1.51882C16.8219 1.51882 17.0161 1.59672 17.162 1.73629L18.2477 2.82048C18.3915 2.96426 18.4722 3.15925 18.4722 3.36257C18.4722 3.56588 18.3915 3.76087 18.2477 3.90466Z" fill="#505050"/>
              <path d="M3.83375 19.8837H14.5682C15.5846 19.8825 16.5591 19.4782 17.2778 18.7595C17.9965 18.0408 18.4008 17.0663 18.402 16.0499V8.85016C18.402 8.6468 18.3212 8.45178 18.1774 8.30798C18.0336 8.16419 17.8386 8.08341 17.6352 8.08341C17.4319 8.08341 17.2369 8.16419 17.0931 8.30798C16.9493 8.45178 16.8685 8.6468 16.8685 8.85016V16.0499C16.8685 16.66 16.6262 17.2451 16.1948 17.6765C15.7634 18.1078 15.1783 18.3502 14.5682 18.3502H3.83375C3.22369 18.3502 2.63861 18.1078 2.20723 17.6765C1.77585 17.2451 1.5335 16.66 1.5335 16.0499V5.31544C1.5335 4.70537 1.77585 4.1203 2.20723 3.68892C2.63861 3.25754 3.22369 3.01519 3.83375 3.01519H11.2252C11.4286 3.01519 11.6236 2.93441 11.7674 2.79061C11.9112 2.64682 11.992 2.45179 11.992 2.24844C11.992 2.04508 11.9112 1.85006 11.7674 1.70627C11.6236 1.56247 11.4286 1.48169 11.2252 1.48169H3.83375C2.81735 1.48291 1.84293 1.88721 1.12422 2.60591C0.40552 3.32462 0.00121749 4.29904 0 5.31544V16.0499C0.00121749 17.0663 0.40552 18.0408 1.12422 18.7595C1.84293 19.4782 2.81735 19.8825 3.83375 19.8837Z" fill="#505050"/>
            </svg>
            <h2 className={styles.removeBgModalTitle}>Remove Background</h2>
          </div>
          <button type="button" className={styles.removeBgModalClose} onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
            </svg>
          </button>
        </div>

        <div className={styles.removeBgModalDivider}></div>

        <div className={styles.removeBgModalContent}>
          <div className={styles.removeBgModalSelectionInfo}>
            <div className={styles.removeBgModalSelectionText}>
              <span>Select Images for Background Removal</span>
              <span className={styles.removeBgModalCount}>
                ({selectedImages.size}/{selectableCount} Selected)
                {alreadyProcessedCount > 0 && (
                  <span className={styles.removeBgModalAlreadyProcessed}>
                    {' '}&middot; {alreadyProcessedCount} already processed
                  </span>
                )}
              </span>
            </div>
            <label className={styles.removeBgModalSelectAll}>
              <input type="checkbox" checked={selectableCount > 0 && selectedImages.size === selectableCount} onChange={onSelectAll} />
              <span>Select All</span>
            </label>
          </div>

          <div className={styles.removeBgModalGrid}>
            {validImages.map((imageData) => {
              const { image, uniqueId } = imageData;
              const isDisabled = image?.backgroundRemoved === true;
              const isSelected = !isDisabled && selectedImages.has(uniqueId);
              return (
                <div
                  key={uniqueId}
                  className={`${styles.removeBgModalImageCard} ${isSelected ? styles.removeBgModalImageCardSelected : ''} ${isDisabled ? styles.removeBgModalImageCardDisabled : ''}`}
                  onClick={() => !isDisabled && onToggleSelection(uniqueId)}
                >
                  <img src={image?.previewUrl || ''} alt="Product image" />
                  {isDisabled && (
                    <div className={styles.removeBgModalImageCardOverlay}>Background removed</div>
                  )}
                  {!isDisabled && (
                    <div className={styles.removeBgModalCheckbox}>
                      {isSelected ? (
                        <div className={styles.removeBgModalCheckboxChecked}>
                          <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 3.5L3.5 6L8 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      ) : (
                        <div className={styles.removeBgModalCheckboxUnchecked}></div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <button
            type="button"
            className={styles.removeBgModalActionButton}
            onClick={onRemoveBackground}
            disabled={selectedImages.size === 0 || processingBgRemoval}
          >
            {processingBgRemoval ? 'Processing...' : 'Remove Background'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
